



























































import os from "os";
import Vue from "vue";
import Register from "../components/RegisterPanel.vue";
import LoginPanel from "../components/LoginPanel.vue";
import ResetPassword from "../components/ResetPasswordPanel.vue";
import raceJs from '../race.js';

let win: any = window;

export default Vue.extend({
  components: {
    Register,
    LoginPanel,
    ResetPassword,
  },
  data() {
    // 获取本机IP
    const interfaces = os.networkInterfaces();
    const addresses: any[] = [];
    for (const k in interfaces) {
      if (interfaces.hasOwnProperty(k)) {
        for (const k2 in interfaces[k]) {
          if (interfaces[k].hasOwnProperty(k2)) {
            const address = interfaces[k][k2];
            if (address.family === "IPv4" && !address.internal) {
              addresses.push(address.address);
            }
          }
        }

      }
    }

    return {
      setting: {
        start: false,
        address: addresses[0],
        port: 18888,
        dir: "",
        showReset: true
      },
      settingDialogVisible: false,
      settingButtonVisible: win.isWin32,
      dialogFormVisible: false,
      dialogResetPassword: false,
      version: raceJs.version,
    };
  },
  methods: {
    setImgDir() {
      const dirs = win.remote.dialog.showOpenDialog({
        properties: ["openDirectory"]
      });
      this.setting.dir = dirs[0];
    },
    onSettingDialogOpen() {
      const settingStr = localStorage.getItem("setting");
      if (settingStr) {
        const setting = JSON.parse(settingStr);
        setting.address = this.setting.address;
        this.setting = setting;
      }
    },
    onSettingDialogClose() {
      this.settingDialogVisible = false;
      // 将设置保存进localStorage
      localStorage.setItem("setting", JSON.stringify(this.setting));
      win.ipcRenderer.send("service-setting", this.setting);
    },
    // 打开注册面板
    openRegisterWin(event: Event) {
      this.dialogFormVisible = true;
    },
    openResetPassWin(event: Event) {
      this.dialogResetPassword = true;
    },
    closeRestPassWin() {
      this.dialogResetPassword = false;
      this.showReset = false;
      this.$nextTick(() => {
        this.showReset = true;
      })
    },
    closeRegisterWin() {
      this.dialogFormVisible = false;
    }
  }
});
